import { render, staticRenderFns } from "./NavbarMobileSmallImageBlocks.vue?vue&type=template&id=4e31c7d4&scoped=true&lang=pug&"
import script from "./NavbarMobileSmallImageBlocks.vue?vue&type=script&lang=js&"
export * from "./NavbarMobileSmallImageBlocks.vue?vue&type=script&lang=js&"
import style0 from "./NavbarMobileSmallImageBlocks.vue?vue&type=style&index=0&id=4e31c7d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31c7d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e31c7d4')) {
      api.createRecord('4e31c7d4', component.options)
    } else {
      api.reload('4e31c7d4', component.options)
    }
    module.hot.accept("./NavbarMobileSmallImageBlocks.vue?vue&type=template&id=4e31c7d4&scoped=true&lang=pug&", function () {
      api.rerender('4e31c7d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/NavbarMobileSmallImageBlocks.vue"
export default component.exports